import { defineStyleConfig } from "@chakra-ui/react";

export const inputTheme = defineStyleConfig({
   variants: {
      outline: {
         field: {
            bgColor: "white",
            borderRadius: "none",
            borderColor: "brandBlue.400",
            borderWidth: "2px",
            height: "52px",
            fontSize: 16,
            px: { base: "24px" },
            _placeholder: { color: "brandBlue.400", opacity: ".5" },
            _hover: {
               borderColor: "brandBlue.500",
            },
            _focus: {
               borderColor: "brandBlue.700",
            },
         },
      },
   },
   defaultProps: {},
});
